import Pension from '../../../assets/illustrations/pension.svg';
import RetiredMan from '../../../assets/illustrations/retired-man.svg';
import Surplus from '../../../assets/illustrations/surplus.svg';

export const HOME_MAIN_TITLE = '¿Qué es la pensión mínima objetivo?';

export const HOME_CARDS_LIST = [
  {
    icon: Pension,
    title: 'Pensión mínima objetivo',
    id: 'pension-minima-objetivo',
  },
  {
    icon: RetiredMan,
    title: 'Requisitos',
    id: 'requirements',
  },
  {
    icon: Surplus,
    title: 'Excedente de pensión',
    id: 'pension-surplus',
  }
];

export const HOME_FOOTNOTES = [
  {
    nRef: '*',
    text: 'Instituto Nacional de Estadística e Informática.'
  },
  {
    nRef: '**',
    text: 'Las garantías negociables te permiten respaldar o asegurar el pago de un crédito en el sistema financiero. Su vencimiento es de dos (2) años desde su emisión.'
  }
];

export const HOME_TEXT = `Descubre el monto que necesitas para obtener la Pensión Mínima Objetivo`;

export const HOME_NEXT_BTN = 'Empezar';